import state from '../state'
import gsap from 'gsap'
import { q1O } from '../util/nE'

class SiteHeader {
  constructor (el) {
    this.el = el
    this.mobileMenuToggle = this.el.querySelector('.site-header__toggle')
    this.mobileNav = document.querySelector('.mobile-nav')
    this.menuItemsWithChildren = this.el.querySelectorAll('.menu-item-has-children')
    this.layer = document.querySelector('.app__layer')
  }

  init () {
    this.buildTimelineIn()

    this.isLG = false
    const mm = gsap.matchMedia()
    mm.add(state.queries.lg, () => {
      this.isLG = true
    })

    if (this.isLG) {
      return
    }

    this.buildMobileMenu()
    this.buildSubMenuToggle()
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => q1O(t),
        duration: 1,
      },
    })

    tl.fromTo(this.el, { autoAlpha: 0 }, { autoAlpha: 1 })
  }

  buildMobileMenu () {
    this.mobileMenuToggle.addEventListener('click', (e) => {
      e.preventDefault()

      const html = document.querySelector('html')
      const isOpen = this.mobileNav.classList.contains('is-active')
      const links = this.mobileNav.querySelectorAll('.mobile-nav__list > li')
      const cta = this.mobileNav.querySelector('.mobile-nav__cta')

      if (isOpen) {
        this.closeMobileMenu(html)
      } else {
        this.mobileNav.classList.add('is-active')
        html.classList.add('is-menu-active')
        this.layer.classList.add('is-active')
        gsap.fromTo(this.mobileNav,
          { height: 0, autoAlpha: 0 },
          { height: 'auto', autoAlpha: 1, duration: 0.7, ease: (t) => q1O(t) }
        )
        gsap.fromTo(
          [links, cta], {
            autoAlpha: 0,
            y: 40,
          }, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.10,
            duration: 0.7,
            ease: (t) => q1O(t),
            delay: 0.1,
          }
        )
      }

      this.mobileMenuToggle.querySelectorAll('span').forEach(span => span.classList.toggle('d-none'))
    })

    this.layer.addEventListener('click', () => {
      if (this.mobileNav.classList.contains('is-active')) {
        const html = document.querySelector('html')
        this.closeMobileMenu(html)
        this.mobileMenuToggle.querySelectorAll('span').forEach(span => span.classList.toggle('d-none'))
      }
    })
  }

  closeMobileMenu (html) {
    gsap.to(this.mobileNav, {
      height: 0,
      autoAlpha: 0,
      duration: 0.5,
      ease: (t) => q1O(t),
      onStart: () => {
        this.layer.classList.remove('is-active')
      },
      onComplete: () => {
        this.mobileNav.classList.remove('is-active')
        html.classList.remove('is-menu-active')
        this.menuItemsWithChildren.forEach(item => {
          const submenu = item.querySelector('.sub-menu')
          if (submenu.classList.contains('is-active')) {
            gsap.to(submenu, {
              height: 0,
              autoAlpha: 0,
              duration: 0.5,
              ease: (t) => q1O(t),
              onComplete: () => {
                submenu.classList.remove('is-active')
                item.classList.remove('is-active')
              },
            })
          }
        })
      },
    })
  }

  buildSubMenuToggle () {
    this.menuItemsWithChildren.forEach(item => {
      const submenu = item.querySelector('.sub-menu')
      const link = item.querySelector('a')

      if (submenu) {
        gsap.set(submenu, { height: 0, autoAlpha: 0, overflow: 'hidden' })

        link.addEventListener('click', (e) => {
          e.preventDefault()

          const isOpen = submenu.classList.contains('is-active')
          const links = submenu.querySelectorAll('.menu-item')

          this.menuItemsWithChildren.forEach(otherItem => {
            const otherSubmenu = otherItem.querySelector('.sub-menu')
            if (otherSubmenu !== submenu && otherSubmenu.classList.contains('is-active')) {
              gsap.to(otherSubmenu, {
                height: 0,
                autoAlpha: 0,
                duration: 0.7,
                ease: (t) => q1O(t),
                onComplete: () => {
                  otherSubmenu.classList.remove('is-active')
                  otherItem.classList.remove('is-active')
                },
              })
            }
          })

          if (isOpen) {
            gsap.to(submenu, {
              height: 0,
              autoAlpha: 0,
              duration: 0.5,
              ease: (t) => q1O(t),
              onComplete: () => {
                submenu.classList.remove('is-active')
                item.classList.remove('is-active')
              },
            })
          } else {
            submenu.classList.add('is-active')
            item.classList.add('is-active')
            gsap.fromTo(submenu,
              { height: 0, autoAlpha: 0 },
              { height: 'auto', autoAlpha: 1, duration: 0.7, ease: (t) => q1O(t) }
            )
            gsap.fromTo(
              links, {
                autoAlpha: 0,
                y: 40,
              }, {
                autoAlpha: 1,
                y: 0,
                stagger: 0.10,
                duration: 0.7,
                ease: (t) => q1O(t),
                delay: 0.1,
              }
            )
          }
        })
      }
    })
  }

  destroy () {
  }
}

export default SiteHeader



//////////////////
// WEBPACK FOOTER
// ./scripts/components/SiteHeader.js
// module id = 67
// module chunks = 0